<template>
  <lay-row>
    <lay-col md="5">
      <div style="padding: 10px;">
        <lay-quote v-if="false">
          <span>数据采集时间选择：</span>
          <lay-date-picker v-model="date" simple type="date" allowClear readonly style="width: 100%"></lay-date-picker>
        </lay-quote>
        <lay-quote v-if="false">
          <p style="margin-bottom: 10px">数据刷新方式：</p>
          <lay-switch v-model="autoUpdate" @change="changeAutoUpdate" onswitch-text="自动"  unswitch-text="手动"></lay-switch>
        </lay-quote>
        <lay-quote>
          <div  style="background-color: whitesmoke;height: 650px" thumbColor="#e2e2e2">
            <lay-collapse v-model="openKeys" accordion>
              <lay-collapse-item title="福州路万科中心35KV变电站" id="0" v-if="page > 0">
                <lay-space fill wrap :size="['0px', '0px']">
                  <lay-button style="margin-top: 10px" fluid="true" :type="i == activeNode ? 'primary' : ''"  size="sm" v-bind:data-id='node.id' v-for="(node, i) in nodeData" v-bind:key="i"   @click="changeNode(i)">({{node.cabinet_no}}){{node.name}}</lay-button>
                </lay-space>
              </lay-collapse-item>
              <lay-collapse-item title="山东路万科中心10KV物业配电室" id="1" v-if="false">
                <lay-space fill wrap :size="['0px', '0px']">
                  <lay-button style="margin-top: 10px" :type="(i + 110) == activeNode ? 'primary' : ''" fluid="true" size="sm" v-for="i in 110" v-bind:key="i + 110" @click="activeNode = i + 110">节点{{i + 110}}</lay-button>
                </lay-space>
              </lay-collapse-item>
              <lay-collapse-item title="标题3" id="2" v-if="page > 2">
                <lay-space fill wrap :size="['10px', '5px']">
                  <lay-button  fluid="true" size="sm" v-for="i in 110" v-bind:key="i + 220">节点{{i}}</lay-button>
                </lay-space>
              </lay-collapse-item>
              <lay-collapse-item title="标题4" id="3" v-if="page > 3">
                <lay-space fill wrap :size="['10px', '5px']">
                  <lay-button  fluid="true" size="sm" v-for="i in 110" v-bind:key="i + 330">节点{{i}}</lay-button>
                </lay-space>
              </lay-collapse-item>
            </lay-collapse>

          </div>
        </lay-quote>
      </div>
    </lay-col>
    <lay-col md="19">
      <div style="padding: 15px;">
        <lay-card>
          <template v-slot:title>
            <lay-row space="10">
              <lay-col xs="24" ><div  style="text-align: left;">&nbsp;{{date}}</div></lay-col>
            </lay-row>
          </template>
          <template v-slot:body>
            <v-chart class="chart" :option="option" ref="chart"></v-chart>
          </template>
        </lay-card>

      </div>
    </lay-col>
  </lay-row>

  <lay-layer :title="''"  v-model="downloadOptionLayer" :move="false" :btn="downloadOptionBtn"  :area="['630px','270px']" :closeBtn="false" :shadeClose="false">
    <div style="padding: 15px">
      <lay-quote type="nm">数据导出时间段选择(单选)：【{{(chooseTime - 1) + '时至' + chooseTime + '时'}}】</lay-quote>
      <lay-space :size="['8px', '8px']" wrap>
        <lay-button v-for="i in 24" v-bind:key="i" :type="chooseTime == i ? 'normal' : ''" @click="chooseTime.value = i">{{i < 10 ? '0' + i : i}}时</lay-button>
      </lay-space>
    </div>
  </lay-layer>

</template>

<script setup>
import { reactive, ref, watch} from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart} from "echarts/charts";
import {TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent,ToolboxComponent,MarkPointComponent} from "echarts/components";
import VChart from "vue-echarts";
import axios from "axios";
import {useInterval} from "@/assets/js/interval";

use([CanvasRenderer, LineChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent, ToolboxComponent, MarkPointComponent]);

const date = ref()
const chart = ref()
const pData = []
const qData = []
const iaData = []
const ibData = []
const icData = []
const xData = []
const nodeData = ref([])
const openKeys = reactive(['0'])
const page = ref(2)
const activeNode = ref(0);
const autoUpdate = ref(false)
const downloadOptionLayer = ref(false);
const chooseTime = ref(1);
const downloadOptionBtn = [
  {text:'确认', callback: ()=>{ alert("确认事件"); downloadOptionLayer.value = false }},
  {text:'取消', callback: ()=>{ downloadOptionLayer.value = false }}
]
const changeAutoUpdate = (val) => {
  console.log(val + " " + autoUpdate.value)
}

const changeNode = (i) => {
  if (activeNode.value != i){
    activeNode.value = i
    xData.length = pData.length = qData.length = iaData.length = ibData.length = icData.length = 0;
    realtime_data()
  }
}




watch(date, (newDate) => {
  console.log(newDate)
})
const realtime_series_config = (name, color, data) => {
  return {
    name: name,
    type: 'line',
    symbol: 'none',
    sampling: 'lttb',
    markPoint: {
      symbol: 'pin',
      data: [
        {type: 'min',name: '最小值', symbolRotate: '180', label: {offset: [0, 10]}},
        {type: 'max', name: '最大值'}
      ],
    },
    itemStyle: {
      color: color
    },
    data: data
  }
}

const option = ref({
  title: {
    text: "",
    left: "left"
  },
  tooltip: {
    trigger: 'axis',
    position: function (pt) {
      return [pt[0], '10%'];
    }
  },
  legend: {
    selected: {
      'p': false,'q' : false,  "Ia": true, 'Ib' : false, 'Ic': false
    }
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: xData
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%']
  },
  toolbox: {
    // feature: {
    //   dataZoom: {
    //     yAxisIndex: 'none'
    //   },
    //   restore: {},
    //   saveAsImage: {}
    // }
  },
  dataZoom: [{
    type: 'inside',
    start: 0,
    end: 100
  }, {
    start: 0,
    end: 10
  }],
  series: [
    realtime_series_config('p', '#27408b', pData),
    realtime_series_config('q', '#ec4cff', qData),
    // realtime_series_config('hz', '#b0493b', []),
    realtime_series_config('Ia', '#EE9A00', iaData),
    realtime_series_config('Ib', '#00b050', ibData),
    realtime_series_config('Ic', '#ff0000', icData),
    // realtime_series_config('uab', '#EE9A00', []),
    // realtime_series_config('ubc', '#00b050', []),
    // realtime_series_config('uca', '#ff0000', []),
  ]
});

const nodes_data = function (){
  axios.get('/nodes')
      .then(function (response) {
        if (response.data.code == 0){
          nodeData.value = response.data.data.list;
        }
      })
      .catch(function () {
      }).finally(() => {

  });
}
nodes_data()


const realtime_data = function (){
  axios.get('/realtime/data?page_id=0&id=' + nodeData.value[activeNode.value]?.id)
      .then(function (response) {
        if (response.data.code == 0){
          if (pData.length > 3000){
            pData.shift();
            qData.shift();
            iaData.shift();
            ibData.shift();
            icData.shift();
            xData.shift();
          }
          pData.push(response.data.data.p);
          qData.push(response.data.data.q);
          iaData.push(response.data.data.ia);
          ibData.push(response.data.data.ib);
          icData.push(response.data.data.ic);
          xData.push(response.data.data.now)
          chart.value.setOption({
            series:[
              realtime_series_config('p', '#27408b', pData),
              realtime_series_config('q', '#ec4cff', qData),
              realtime_series_config('Ia', '#EE9A00', iaData),
              realtime_series_config('Ib', '#00b050', ibData),
              realtime_series_config('Ic', '#ff0000', icData),
            ],
            xAxis: {
              data: xData
            }
          })
        }

      })
      .catch(function () {
      }).finally(() => {

  });
}

useInterval(realtime_data, 2000);
</script>

<style scoped>
.chart{
  height: 650px;
  padding-top: 20px;
}
.download{
  font-size: 23px;cursor: pointer;
}
.refresh{
  font-size: 18px;cursor: pointer;
}
</style>